const PreVettedTherapistsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.6667 56V50.6667C42.6667 47.8377 41.5429 45.1246 39.5426 43.1242C37.5422 41.1238 34.8291 40 32.0001 40H13.3334C10.5044 40 7.79133 41.1238 5.79094 43.1242C3.79055 45.1246 2.66675 47.8377 2.66675 50.6667V56"
        stroke="#06AEB3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6667 29.3333C28.5577 29.3333 33.3333 24.5577 33.3333 18.6667C33.3333 12.7756 28.5577 8 22.6667 8C16.7756 8 12 12.7756 12 18.6667C12 24.5577 16.7756 29.3333 22.6667 29.3333Z"
        stroke="#027C80"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.3333 29.3333L50.6666 34.6667L61.3333 24"
        stroke="#FFA473"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PreVettedTherapistsIcon;
